import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LgvClientService } from '../../core/services/lgv-client.service';
import { GreaterThanZero } from '../../core/utility/lgv-form-validator';
import { LgvModel } from '../../data-models/longevity.model';
import { environment as env } from '../../../environments/environment';
import { DatePipe } from '@angular/common';
import { LgvTSHelper } from '../../core/utility/ts-helper';
import { HttpClient } from '@angular/common/http';
import { NotificationService } from '../../core/notifications/notification.service';
import { LgvUserService } from '../../core/services/lgv-user.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'lus-create-loan',
    templateUrl: './create-loan.component.html',
    styleUrls: ['./create-loan.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateLoanComponent implements OnInit, OnDestroy {
    _form: UntypedFormGroup;
    agendId: string = '';
    clientId: string = '';
    _ClientSS: LgvModel.ClientSnapshot = null;
    ClientSS$ = new BehaviorSubject(this._ClientSS);
    response$ = new BehaviorSubject(null);
    onDestroy$ = new Subject();

    constructor(
        private FB: UntypedFormBuilder,
        private LgvClientSvc: LgvClientService,
        public LgvUserSvc: LgvUserService,
        public Notifications: NotificationService,
        private datePipe: DatePipe,
        private http: HttpClient,

    ) { }

    ngOnInit() {
        this.LgvUserSvc.initLookups();

        this.LgvClientSvc.PartialSnapShot$.pipe(first(f => f !== null)).subscribe(x => {
            this.agendId = x.clientInfo.ownerId;
            this.ClientSS$.next(x);
            this.InitManualLoan(x);
        });
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    InitManualLoan(ss) {
        this._form = this.FB.group({
            propertyAddress: [null, [Validators.required]],
            propertyCity: [null, [Validators.required]],
            propertyState: [null, [Validators.required]],
            propertyZip: [null, [Validators.required]],
            closingDate: [null, [Validators.required]],
            totalLoanAmount: [null, [Validators.required, GreaterThanZero()]],
            appraisedValue: [null, [Validators.required, GreaterThanZero()]],
            interestRate: [null, [Validators.required, GreaterThanZero()]],
            loanTerm: [360, [Validators.required, GreaterThanZero()]],
            clientId: [this.LgvClientSvc.ClientID$.value],
            loanTypeId: ['D03831A8-83B6-EA11-9B05-000D3A3287E5'],
            lienTypeId: ['F3A23182-20AC-EA11-9B05-000D3A3287E5'],
            loanPurposeTypeId: [null]
        });
        this._form.patchValue({
            propertyAddress: ss.clientInfo.address1,
            propertyCity: ss.clientInfo.city,
            propertyState: ss.clientInfo.state,
            propertyZip: ss.clientInfo.zipCode
        });
        this.LgvClientSvc.SelectedProperty$.pipe(first()).subscribe((property) => {
            if (!!property) {
                this._form.patchValue({
                    propertyAddress: property.propertyInfo.address,
                    propertyCity: property.propertyInfo.city,
                    propertyState: property.propertyInfo.state,
                    propertyZip: property.propertyInfo.zip
                });
            }
        })
    }
    onSubmit() {
        this.response$.next(null);
        if (this._form.invalid) { return; }
        let bldUrl = `${env.LgvApiBaseUrl}/loans`;


        let model = this._form.getRawValue();

        model.closingDate = this.datePipe.transform(this._form.get('closingDate').value, 'yyyy-MM-dd');
        model.totalLoanAmount = LgvTSHelper.stringToNumber(this._form.get('totalLoanAmount').value);
        model.appraisedValue = LgvTSHelper.stringToNumber(this._form.get('appraisedValue').value);
        model.interestRate = LgvTSHelper.stringToNumber(this._form.get('interestRate').value);
        model.loanTerm = LgvTSHelper.stringToNumber(this._form.get('loanTerm').value);
        console.log(model);
        this.http.post<any>(bldUrl, model).pipe(takeUntil(this.onDestroy$)).subscribe(x => {
            this.response$.next(x);
            this.LgvClientSvc.LoadSnapshotForNonClient(this._form.get("clientId").value, true);
            this.LgvClientSvc.SnapShot$.pipe(first(f => f !== null)).subscribe(ss => {
                console.log('*** Have Standard Client Snapshot from Manual loan ***:');
            });
            this.Notifications.success("Loan successfully created.")
        }, err => {
            this.response$.next(err);
            this.Notifications.error("There was an error trying to create loan details.")
        });
        return this.response$;
    }

}
